import { useEffect, useRef } from "react";

export const useDismissiblePopover = (isOpen, onDismiss) => {
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleMouseDown = (event) => {
      if (
        !popoverRef.current?.contains(event.target) &&
        !triggerRef.current?.contains(event.target)
      ) {
        onDismiss();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key !== "Escape") return;

      event.preventDefault();
      const trigger = triggerRef.current;
      onDismiss();
      trigger?.focus();
    };

    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onDismiss]);

  return { popoverRef, triggerRef };
};
